module.exports = __webpack_public_path__ + "static/img/DSC_2678.12999bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2678.jpg
// module id = 273
// module chunks = 0